module.exports = __webpack_public_path__ + "img/amusement.d1f9e18d.jpg";